<template>
  <div style="width: 600px;margin: 30px auto 0;">
    <div v-if="isDisabled" class="tip-message">
      您已设置过支付密码，若修改可跳转到<router-link
        to="/systemManage/payPassword/editPassword"
        class="modify-link"
        >修改支付密码</router-link
      >页面
    </div>
    <el-form ref="form" :rules="rules" :model="form" label-width="160px">
      <el-form-item label="设置支付密码" prop="payPwd" required>
        <el-input
          v-model="form.payPwd"
          show-password
          placeholder="请输入6位数字"
          maxlength="6"
          :disabled="isDisabled"
          @input="handleInput($event, 'payPwd')"
        />
      </el-form-item>
      <el-form-item label="确认支付密码" prop="confirmPwd" required>
        <el-input
          v-model="form.confirmPwd"
          show-password
          placeholder="请确认支付密码"
          maxlength="6"
          :disabled="isDisabled"
          @input="handleInput($event, 'confirmPwd')"
        />
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button type="primary" @click="handleSubmit" :disabled="isDisabled">
        立即提交
      </el-button>
      <el-button @click="resetForm('form')" :disabled="isDisabled"
        >重置</el-button
      >
    </div>
  </div>
</template>

<script>
import { createPSW, isexistPSW } from "@/api/pay.js";
import { Base64 } from "js-base64";
export default {
  name: "AddPassword",
  data() {
    const validatePayPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入支付密码"));
      } else if (!/^\d{6}$/.test(value)) {
        callback(new Error("请输入6位数字"));
      } else {
        callback();
      }
    };
    const validateConfirmPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请确认支付密码"));
      } else if (value !== this.form.payPwd) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      isDisabled: false,
      form: {
        payPwd: "",
        confirmPwd: ""
      },
      rules: {
        payPwd: [{ validator: validatePayPwd, trigger: "blur" }],
        confirmPwd: [{ validator: validateConfirmPwd, trigger: "blur" }]
      }
    };
  },
  created() {
    this.checkExistPassword();
  },
  methods: {
    async checkExistPassword() {
      try {
        const res = await isexistPSW();
        console.log("支付密码是否存在:", res);
        if (res.data.isHave === "1") {
          this.isDisabled = true;
          // this.$message.warning("您已设置过支付密码");
        }
      } catch (error) {
        console.error("检查支付密码是否存在失败:", error);
      }
    },
    async handleSubmit() {
      try {
        const valid = await this.$refs.form.validate(); // 使用 await 获取校验结果
        if (valid) {
          const res = await createPSW({
            payPassword: Base64.encode(this.form.payPwd)
          });
          console.log("支付密码设置成功:", res);
          if (res.status === 0) {
            this.$message.success("支付密码设置成功");
            this.isDisabled = true;
          }
        }
      } catch (error) {
        console.error("设置支付密码失败:", error);
        // this.$message.error("设置支付密码失败，请稍后重试");
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleInput(value, field) {
      this.form[field] = value.replace(/\D/g, "");
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
.tip-message {
  color: #e6a23c;
  margin-bottom: 15px;
}
.modify-link {
  color: #409eff;
  text-decoration: none;
}
.modify-link:hover {
  text-decoration: underline;
}
</style>
